<template>
    <div id="contract_list" class="internal-table-border">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div v-if="customerContractVal != undefined">
            <vue-good-table
                ref="listContractTable"
                mode="remote"
                title="Contract"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-select-all="onSelectAll"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                enabled: true,
                position: 'top',
                perPage: perPage,
                perPageDropdown:dropDownPerPage,
                dropdownAllowAll: false,
                }"
                :search-options="{
                enabled: false,
                }">
                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                    <div :key="key">
                        <div v-if="props.column.field == 'action'">
                        </div>
                        <div v-else-if="props.column.field == 'code' && canViewContract === true">
                            <router-link title="View Contract" class="color-blue" v-bind:to="{name: 'ContractView',params:{id:props.row.id}}">{{props.row.code}}</router-link>
                        </div>
                        <div v-else>
                            {{props.formattedRow[props.column.field]}}
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </div>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}}</div>

                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>

                    <div class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()"><i class="fp-export"></i> Export</a>
                        <router-link v-if="canAddContract && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'ContractCreate'}" > <i class="fp-add"> </i> Add</router-link>
                        <router-link v-if="canAddContractAsset && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'ContractAssetDetailCreate'}" > <i class="fp-add"> </i> Add Contract Asset</router-link>
                        <router-link v-if="canAddContract && hideButton === false" class="btn btn-secondary" v-bind:to="{name: 'ContractAssetDetailList'}" > <i class="fp-truck"> </i> Contract Assets</router-link>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li>
                                    <router-link v-if="canAddContract && hideButton === false" v-bind:to="{name: 'ContractCreate'}">Add</router-link>
                                </li>
                                <li>
                                    <router-link v-if="canAddContractAsset && hideButton === false" v-bind:to="{name: 'ContractAssetDetailCreate'}"> Add Contract Asset</router-link>
                                </li>
                                <li>
                                    <router-link v-if="canAddContract && hideButton === false" class="" v-bind:to="{name: 'ContractAssetDetailList'}" > Contract Assets</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contract-lists">
                        <data-table-filter-config :moduleName="'contractList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'contractList'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="listContractTable"
                                      mode="remote"
                                      title="Contract"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      @on-select-all="onSelectAll"
                                      :rows="rows"
                                      :pagination-options="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      perPageDropdown:dropDownPerPage,
                                      dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: canRemoveContract,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template v-if="canEditContract === true">
                                                      <router-link title="Edit Contract" class="fp-edit" v-bind:to="{name: 'ContractEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                              </div>
                                              <div v-else-if="props.column.field == 'code' && canViewContract === true">
                                                  <router-link title="View Contract" class="color-blue" v-bind:to="{name: 'ContractView',params:{id:props.row.id}}">{{props.row.code}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button v-if="canRemoveContract == true" id="deleteContractBtn" v-on:click.prevent="ContractDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";


import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ContractList",
        metaInfo() {
            if (this.customerContractVal == undefined) {
                return {

                    title: "Contract List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            customerContractVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            pageKey: "_contract_list_",
            pageTitle:"Contract List",
            hideButton: false,
            firstLoad: 0,
             permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type Code',
                    field: 'contract_type',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Type Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer',
                    field: 'customer_name',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Billing Method',
                //     field: 'contract_billing_method',
                //     filterable: true,
                //     fpFieldType:"text",
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Contract Billing Method", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Billing Frequency',
                    field: 'contract_billing_frequency',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Billing Frequency", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Cpi Code',
                    field: 'cpi_code',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Cpi Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Contract Term',
                //     field: 'contract_term',
                //     fpFieldType:"text",
                //     filterable: true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Contract Term", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Expiry Date',
                //     field: 'expiry_date',
                //     fpFieldType:"date",
                //     filterable: true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            canAddContract: false,
            canEditContract: false,
            canViewContract: false,
            action:'list',
            canAddContractAsset:false,
            canRemoveContract:false,
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_contract') {
                            self.cantAccessPage = true;
                        }

                        if (permissions[i].name == 'view_contract') {
                            self.canViewContract = true;
                        }

                        if (permissions[i].name == 'add_contract') {
                            self.canEditContract = true;
                            self.canAddContract = true;
                        }
                        if (permissions[i].name == 'delete_contract') {
                          if(self.$route.query.flag == 'leaseReport'){

                              self.canRemoveContract = false;
                            } else{
                               self.canRemoveContract = true;
                            }

                        }
                        if (permissions[i].name == 'add_contract_asset_detail') {
                            self.canAddContractAsset = true;
                        }


                    }
                }

            }
        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('customer_contracts');
        },
        mounted: function() {
            var self = this;
            //self.loadList();
            // self.getPermissions();
            if(self.$route.query.flag == 'leaseReport'){
              self.hideButton = true;
              self.pageTitle = "Lease Contracts"
              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            }
            this.$root.$on('customer_contracts', () => {
                    var path = window.location.pathname;
                    var contract = path.split("/");
                    self.customerId = contract[3];
                    self.customerContractVal = "loadList";
                    self.flag = 'selectedCustomerContract';

                    //for now hide unit and name datatable column
                    for (let index = 0; index < this.columns.length; index++) {

                        if(this.columns[index].field == 'customer_name'){
                            this.$set(this.columns[index], 'hidden', true);
                        }

                    }

                    self.getPermissions();
                    self.loadList();
            });

            //when component list directly call from url instead of in view page than call permission request
            if ( self.customerContractVal == undefined || self.customerContractVal == 'getcurrentcontract' || self.customerContractVal == 'getpastcontract') {
                self.getPermissions();
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listContractTable.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.serverParams.page = 1;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('contract_type');
                    field:('customer_name');
                    field:('location');
                    field:('contract_billing_method');
                    field:('contract_billing_frequency');
                    field:('cpi_code');
                    field:('effective_date');
                    field:('expiry_date');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.contract_type || filters.customer_name || filters.location || filters.contract_billing_method
                    || filters.contract_billing_frequency || filters.cpi_code || filters.effective_date || filters.expiry_date) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listContractTable'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },
            loadList() {
                var self = this;
                if( self.customerContractVal == 'dontLoadList' ){
                    return;
                }
                // if( self.customerContractVal == 'getcurrentcontract' ){
                //     self.flag = 'getcurrentcontract';
                // }else if(self.customerContractVal == 'getpastcontract'){
                //     self.flag = 'getpastcontract';
                // }

                var data = this.$refs['listContractTable'].selectedRows;

                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listContractTable'].selectedRows[i].id)
                }

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    id:self.customerId,
                    selectedRows:use,
                    all:self.serverParams.selectedAll,
                    action:self.action,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/contract/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if ( self.action == 'delete'){

                            self.action = 'list';
                            self.cancelAll(true);
                            self.loadList();
                        }
                        if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();

                        }

                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if ( self.action == 'delete'){
                            self.generateStatusCodeMessage(jqXHR,true,'contract-delete')
                        }else if ( self.action == 'export'){
                            self.generateStatusCodeMessage(jqXHR,true,'contract-export')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'contract-list')
                        }

                    }
                });
            },
            ContractDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Contract?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      $("#deleteContractBtn").val("Deleting ...");
                      self.action = 'delete';
                      self.loadList();
                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Contract? ')) {


                     return;

                    // self.loading = true;
                    // $("#deleteContractBtn").val("Deleting ...");
                    // $.ajax({
                    //     url: process.env.ROOT_API + "/contract/delete",
                    //     type: "POST",
                    //     data: 'ids=' + use,
                    //     headers: this.ajxHeaders,
                    //     dataType: 'json',
                    //     success: function (data) {
                    //         self.loading = false;
                    //         setTimeout(function () {
                    //         $(".alert-success").removeClass("show");
                    //             $(".alert-success").addClass("hide");
                    //         }, 10000);
                    //         setTimeout(function () {
                    //             $("#deleteContractBtn").val("Delete");
                    //         }, 10000);
                    //         self.rows = data.content.row;
                    //         if (data.code == '200') {
                    //             self.rows = data.content.row;
                    //             self.totalRecords = data.content.totalRecords;
                    //             self.loadList();
                    //         }
                    //     },
                    //     error: function (jqXHR, exception) {
                    //         self.loading = false;
                    //         self.generateStatusCodeMessage(jqXHR,true,'contract-data-delete')
                    //     }
                    // });
              //  }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ContractList.vue